import { render, staticRenderFns } from "./USRiskManagementFilters.vue?vue&type=template&id=c89b026a"
import script from "./USRiskManagementFilters.vue?vue&type=script&lang=js"
export * from "./USRiskManagementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports